/**
 * Expert help lead form (DPUX PDP). Depends on subscription-form-common.js
 * for validateEmail, validatePhone, createFieldsArray, createSMSFieldsArray, traceId.
 */
document.addEventListener("alpine:init", function () {
  Alpine.data("expertHelpLeadForm", function (scopeId) {
    return {
      scopeId: scopeId,
      settings: {},
      loading: false,
      errMsg: "",
      fullName: "",
      contact_email: "",
      showSuccessModal: false,

      id(suffix) {
        return "expert-help-" + suffix + "-" + this.scopeId;
      },

      init() {
        var jsonEl = document.getElementById("expert-help-json-" + this.scopeId);
        if (jsonEl && jsonEl.textContent) {
          try {
            this.settings = JSON.parse(jsonEl.textContent);
          } catch (e) {
            console.warn("expertHelpLeadForm: bad settings JSON", e);
          }
        }
      },

      CODE: { SUCCESS: "0", PHONE_SIGNED: "2058", WAIT_EMAIL: "20199" },

      getEmail() {
        var el = document.getElementById(this.id("email"));
        return el ? el.value.trim() : "";
      },
      getPhone() {
        var el = document.getElementById(this.id("phone"));
        return el ? el.value.trim() : "";
      },
      getPhoneCode() {
        return this.settings.phone_code || "+1";
      },

      getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
        return null;
      },

      getHeader() {
        var es = theme.emailSubscription;
        return {
          "Content-Type": "application/json",
          apiKey: es.apiKey,
          traceId: typeof traceId !== "undefined" ? traceId : window.traceId,
          "X-appid": es.xAppid,
          "Accepted-Language": es.acceptedLanguage,
        };
      },

      async subscribeEmail(email) {
        var es = theme.emailSubscription;
        var base = Object.assign({}, this.settings);
        if (base.subscription_text_1_id && (this.fullName || "").trim()) {
          base.subscription_text_1_value = (this.fullName || "").trim();
        }
        var fieldsArray = createFieldsArray(base);
        var contactListId = getContactListId(this.settings);
        var cookieVal = this.getCookie("subscribe_info");
        var eventTracking = null;
        if (cookieVal) {
          try {
            eventTracking = JSON.parse(decodeURIComponent(cookieVal));
            if (eventTracking) delete eventTracking.ts;
          } catch (err) {
            console.warn("subscribe_info cookie parse failed", err);
          }
        }
        var body = {
          email: email,
          contactListId: contactListId,
          fields: fieldsArray,
        };
        if (eventTracking) body.eventTracking = eventTracking;
        var res = await fetch(es.apiUrlFooter, {
          method: "POST",
          headers: this.getHeader(),
          body: JSON.stringify(body),
        });
        return res.json();
      },

      async subscribeSMS(email, phone) {
        var es = theme.emailSubscription;
        var fieldsArray = createSMSFieldsArray(this.settings);
        var contactListId = getContactListId(this.settings);
        var smsContactListId = getSMSContactListId(this.settings);
        var SMS_OPT_IN_ID = "3487";
        var optInField = fieldsArray.find(function (f) {
          return String(f.id) === SMS_OPT_IN_ID;
        });
        if (!optInField) {
          fieldsArray.unshift({
            id: SMS_OPT_IN_ID,
            type: "single",
            value: 1,
            overwrite: true,
          });
        }
        var trytimes = 3;
        var self = this;
        var CODE = this.CODE;
        async function checkEmail() {
          trytimes--;
          try {
            var infoData = await fetch(
              es.infoApiUrl +
                "?" +
                new URLSearchParams({ email: email }).toString(),
              { method: "GET", headers: self.getHeader() }
            ).then(function (r) {
              return r.json();
            });
            if (infoData.code !== CODE.SUCCESS) {
              if (trytimes > 0) return await checkEmail();
              return infoData;
            }
            if (!infoData.data.acceptsMarketing) {
              var emailData = await fetch(es.apiUrlFooter, {
                method: "POST",
                headers: self.getHeader(),
                body: JSON.stringify({
                  email: email,
                  contactListId: contactListId,
                  fields: fieldsArray,
                }),
              }).then(function (r) {
                return r.json();
              });
              if (emailData.code !== CODE.SUCCESS) {
                if (trytimes > 0) return await checkEmail();
                return emailData;
              }
            }
            return;
          } catch (error) {
            console.error(error);
          }
        }
        var emailData = await checkEmail();
        if (emailData) {
          return emailData;
        }

        var apiBody = {
          email: email,
          phone: phone,
          contactListId: contactListId,
          smsContactListId: smsContactListId,
          fields: fieldsArray,
        };
        return fetch(es.apiUrlFooter, {
          method: "POST",
          headers: this.getHeader(),
          body: JSON.stringify(apiBody),
        }).then(function (r) {
          return r.json();
        });
      },

      async submit() {
        this.errMsg = "";
        var email = this.getEmail();
        var phone = this.getPhone();
        var code = this.getPhoneCode();
        var name = (this.fullName || "").trim();

        if (!name) {
          this.errMsg = this.settings.hint_full_name_empty || "Please enter your full name.";
          return;
        }
        if (!validateEmail(email)) {
          this.errMsg = this.settings.hint_email_valid || "Please enter a valid email address.";
          return;
        }
        if (!validatePhone(code, phone)) {
          this.errMsg = this.settings.hint_phone_valid || "Please enter a valid phone number.";
          return;
        }

        if (typeof theme === "undefined" || !theme.emailSubscription) {
          this.errMsg = "Subscription service unavailable.";
          return;
        }

        this.loading = true;
        try {
          var emailRes = await this.subscribeEmail(email);
          if (emailRes.message !== "Success") {
            this.errMsg =
              this.settings.hint_oops ||
              "Oops... Something went wrong, please refresh and try again.";
            return;
          }
          var fullPhone = code + phone;
          var smsRes = await this.subscribeSMS(email, fullPhone);
          if (smsRes.code === "2058") {
            this.errMsg =
              this.settings.hint_phone_signed ||
              "This number has been signed, please use another phone number";
            return;
          }
          if (smsRes.code === "20199") {
            this.errMsg =
              this.settings.hint_email_sms_subscribed ||
              "Please subscribe email address first.";
            return;
          }
          if (smsRes.code !== "0") {
            this.errMsg =
              this.settings.hint_oops ||
              "Oops... Something went wrong, please refresh and try again.";
            return;
          }
          this.showSuccessModal = true;
          this.fullName = "";
          var emEl = document.getElementById(this.id("email"));
          var phEl = document.getElementById(this.id("phone"));
          if (emEl) emEl.value = "";
          if (phEl) phEl.value = "";
        } catch (err) {
          console.error(err);
          this.errMsg =
            this.settings.hint_oops ||
            "Oops... Something went wrong, please refresh and try again.";
        } finally {
          this.loading = false;
        }
      },

      closeSuccessModal() {
        this.showSuccessModal = false;
      },
    };
  });
});
